/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/number/Mod.ts
 * @create:      2025-06-27 10:43:28.151
 * @modify:      2025-07-11 21:19:12.821
 * @version:     6.0.0
 * @times:       6
 * @lines:       54
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Computes the true mathematical modulo of a number, ensuring a non-negative result even for negative inputs.
 *
 * This function returns the remainder of the division of `num` by `n`, always in the range [0, n).
 * It handles negative numbers correctly, unlike the `%` operator in JavaScript/TypeScript.
 *
 * @param num - The dividend.
 * @param n - The divisor (must be a non-zero number).
 * @returns The non-negative remainder of `num` divided by `n`.
 *
 * @example
 * Mod(5, 3);    // returns 2
 * Mod(-5, 3);   // returns 1
 * 
 * @since 4.0.0
 * @version 2021-12-14
 */
export function Mod(num: number, n: number) {
    // https://stackoverflow.com/questions/4467539/javascript-modulo-gives-a-negative-result-for-negative-numbers
    return ((num % n) + n) % n;
}
